// extracted by css-extract-rspack-plugin
export default {"SectionContainer":"Overview-module__SectionContainer__Uh2tH","TableFooter":"Overview-module__TableFooter__jvjjX"};